<template>
  <li :class="['mobile-city', { active }]">
    <span class="link" @click="$f.showNav('city')">
      Ваш город
      <em>{{ CITY.name }}</em>
    </span>
    <div class="tree-menu depth2">
      <vue-client-only>
        <mobile-menu-header
          title="Выбор региона доставки"
          show-back
          @back.stop="$f.showNav()"
        />
      </vue-client-only>
      <div class="mobile-city-container">
        <city-search
          v-if="active"
          :locally="$f.navSection === 'selectCity'"
          @choose="changeCity"
        />
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueClientOnly from 'vue-client-only';
import MobileMenuHeader from './mobile-menu-header.vue';
import CitySearch from './city-search.vue';

export default {
  name: 'mobile-city',

  components: {
    MobileMenuHeader,
    CitySearch,
    VueClientOnly,
  },

  computed: {
    ...mapGetters({
      CITY: 'user/city',
    }),

    active() {
      return ['city', 'selectCity'].includes(this.$f.navSection);
    },
  },
  methods: {
    ...mapActions({
      UPDATE_CITY: 'user/updateCity',
    }),

    changeCity(city) {
      if (this.$f.navSection === 'selectCity') { // локальная смена города
        this.$city.$emit('city', city);
        this.$city.hideCityConfirmation();
      } else if (this.$f.navSection === 'city') { // глобальная
        this.$city.requestConfirmation({ city, reloadPage: true });
      }
    }
  }
}
</script>

<style lang="scss">
.mobile-city {
  .link {
    em {
      margin-left: auto;
      font-weight: normal;
      font-style: normal;
      color: $gray;
    }
  }
  &-container {
    padding: $containerGapMobile 0;
    .city-search {
      width: auto;
      h3 {
        display: none;
      }
      .lists {
        max-height: initial;
        flex-wrap: nowrap;
      }
    }
  }
}
</style>
